import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useStoreApi } from '../../api';
import { storeKeys } from '../../query-key-factory';
import { StoreItemResponse } from '../../types';
import { TicketStoreItemType, TicketsType } from './types';

const useDeleteTicket = <T extends TicketsType>({ ticketsType }: { ticketsType: T }) => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const deleteEventTicket = async ({
    ticketId,
    eventId,
    causeId,
  }: {
    ticketId: string;
    eventId: string;
    causeId: string;
  }) => {
    const { data } = await StoreApi.delete<StoreItemResponse<TicketStoreItemType<TicketsType>>>(
      `/store_items/events/${eventId}/${ticketsType}/${ticketId}?cause_id=${causeId}`
    );
    return data;
  };

  return useMutation({
    mutationFn: deleteEventTicket,
    onSuccess(_, variables) {
      const { causeId, eventId } = variables;
      const tickets = ticketsType === 'tickets' ? 'tickets' : 'seasonPasses';
      void queryClient.invalidateQueries({
        queryKey: storeKeys.id(causeId).items.events.id(eventId)[tickets].all,
      });
    },
  });
};

export { useDeleteTicket };
